import axios from "axios";
import { environment } from "../../environments/environment";


export interface Company {
    fantasy_name: string,
    cnpj: string,
    company_email: string,
    phone: string,
    postcode: string,
    address: string,
    address_number: string,
    city_id: string,
    website: string,
    description: string,
    motivation: string,
    full_name: string,
    password: string,
    cpf: string,
    gender: string,
    date_of_birth: string,
    manager_email: string
}

export interface CreateCompany {
    fantasy_name: string,
    cnpj: string,
    company_email: string,
    phone: string,
    postcode: string,
    address: string,
    address_number: string,
    city_id: string,
    website: string,
    description: string,
    motivation: string,
    full_name: string,
    password: string,
    cpf: string,
    gender: string,
    date_of_birth: string,
    manager_email: string
}

export const createCompany = async (data: CreateCompany): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/company_new/register/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const listCompanies = async (params?: any): Promise<{
    totalCount: number,
    data: any[]
}> => {
    let search = '';
    let id = '';

    if (params?.search) {
        search = `, search: "${params.search}"`
    };

    if (params?.id) {
        id = `, id: ${params.id}`
    };

    const response = await axios.post(`${environment.apiUrl}/graphql`,
        {
          "operationName": "AllJobs",
          "query": `query AllJobs {
                        allCompanies(${search} ${id}) {
                            edges {
                                node {
                                    id
                                    name
                                }
                            },
                            totalCount
                        }
                    }`,
          "variables": {}
        }, {
          headers: {
            "content-type": "application/json"
          }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return {
        data: response.data.data.allCompanies.edges.map((x: any) => x.node),
        totalCount: response.data.data.allCompanies.totalCount
    };
};

export const retrieveCompany = async () => {
    const response = await axios.get<Company>(environment.apiUrl+'/api/candidate/'+localStorage.getItem('candidate_id'), {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const retrieveCompanyManager = async () => {
    const response = await axios.get<any>(environment.apiUrl+'/api/managers/'+localStorage.getItem('manager_id'), {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};